module.exports = __webpack_public_path__ + "static/media/avive_aed_accepted_hover.c61bfd23.svg";